import { Dispatch, FC, SetStateAction } from "react";
import { FormType } from "../../common";
import { DairyV2Input } from "../../../../models/Intervention/DairyV2Intervention";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { CSSClassesList } from "../../../../helpers/helperTypes";
import { processAndStageStylesV2 } from "../../../../../../_metronic/layout";
import { UserProfilePrefs } from "../../../../../modules/Helpers/UserProfilePrefs";
import { useFormContext } from "react-hook-form";
import { DsmGrid } from "@dsm-dcs/design-system-react";
import { Spacer } from "../../../helpers/Spacer";
import ReactHookDsmInput from "../../../../../modules/Helpers/ReactHookDsmInput2";
import { unitLong } from "../../../../utils/unit-utils";
import RowTextFieldWithMetrics from "../../../../../modules/Farms/Intervention/RowControlledTextFieldWithMetrics2";
import EditModeButtons from "../../../helpers/EditModeButtons";
import { isFieldFilled } from "../CommonDataParts/InterventionGenericInfoDialog";

interface DairyV2InputNewAnimalsCowComponentProps {
  fieldItemPrefix: string;
  formType: FormType;
  defaultStageData: DairyV2Input;
  isNewAnimalsEdit: boolean;
  setIsNewAnimalsEdit: Dispatch<SetStateAction<boolean>>;
  resetEdit: () => void;
};

const DairyV2InputNewAnimalsCowComponent: FC<DairyV2InputNewAnimalsCowComponentProps> = ({
  fieldItemPrefix,
  formType,
  defaultStageData,
  isNewAnimalsEdit,
  setIsNewAnimalsEdit,
  resetEdit,
}) => {
  const intl = useIntl();
  const classes: CSSClassesList = processAndStageStylesV2();
  const userUOM = UserProfilePrefs.getInstance().getUserUnitPrefs();
  const fc = useFormContext<DairyV2Input>();

  return (
    <DsmGrid className={classes.dsmGridTwoColumnNoRowSpacing}>
      {!isNewAnimalsEdit ? (
        <>
          {isFieldFilled(fc.getValues(`${fieldItemPrefix}.averageWeightNewAnimals`)) ? (
            <div>
              <RowTextFieldWithMetrics
                name={`${fieldItemPrefix}.averageWeightNewAnimals`}
                label={intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS' })}
                tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.TOOLTIP' })}
                type="number"
                metricUnit={intl.formatMessage(
                  { id: 'SUSTELL.STAGE.DAIRY.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.ADORNMENT' },
                  { unit: userUOM?.unitBarnOutputMass ? unitLong(userUOM.unitBarnOutputMass) : 'kg' }
                )}
                baseline={defaultStageData.averageWeightNewAnimals}
                displayTypeSelect={false}
                disabled
              />
              <Spacer />
            </div>
          ) : (
            <ReactHookDsmInput
              name={`${fieldItemPrefix}.originalAverageWeightNewAnimals`}
              label={intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS' })}
              tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.TOOLTIP' })}
              adornment={intl.formatMessage(
                { id: 'SUSTELL.STAGE.DAIRY.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.ADORNMENT' },
                { unit: userUOM?.unitBarnOutputMass ? unitLong(userUOM.unitBarnOutputMass) : 'kg' }
              )}
              type="number"
              defaultValue={defaultStageData.averageWeightNewAnimals ?? ''}
              disabled
            />
          )}
          <div />
        </>
      ) : (
        <>
          <div>
            <RowTextFieldWithMetrics
              name={`${fieldItemPrefix}.averageWeightNewAnimals`}
              label={intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS' })}
              tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.TOOLTIP' })}
              type="number"
              metricUnit={intl.formatMessage(
                { id: 'SUSTELL.STAGE.DAIRY.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.ADORNMENT' },
                { unit: userUOM?.unitBarnOutputMass ? unitLong(userUOM.unitBarnOutputMass) : 'kg' }
              )}
              baseline={defaultStageData.averageWeightNewAnimals}
              disabled={false}
            />
            <Spacer />
          </div>
          <div />
        </>
      )}
      {formType !== FormType.View &&
        <EditModeButtons
          isEditing={isNewAnimalsEdit}
          onEdit={() => setIsNewAnimalsEdit(true)}
          onCancel={resetEdit}
        />}
    </DsmGrid>
  )
};

export default DairyV2InputNewAnimalsCowComponent;
